// Home hero video. Set these once the office clip is ready (8–12 s, muted, about 1.5 MB, 720p),
// e.g. HERO_VIDEO = '/media/hero.mp4' and HERO_POSTER = '/media/hero-poster.webp' (files in public/media).
// While HERO_VIDEO is null the hero shows the animated aurora and a labelled placeholder.
export const HERO_VIDEO = null;
export const HERO_POSTER = null;

// Illustrations in public/img. These are generated stand-ins (objects and places only, never people).
// To use a real photo instead, save it over the same file name; nothing else needs to change.
export const IMG = {
  life: '/img/obj-life.webp',
  health: '/img/obj-health.webp',
  vehicle: '/img/obj-vehicle.webp',
  home: '/img/obj-home.webp',
  business: '/img/obj-business.webp',
  travel: '/img/obj-travel.webp',
  invest: '/img/obj-invest.webp',
  sceneHealth: '/img/scene-health.webp',
  sceneLife: '/img/scene-life.webp',
  sceneVehicle: '/img/scene-vehicle.webp',
  sceneHome: '/img/scene-home.webp',
  sceneBusiness: '/img/scene-business.webp',
  sceneTravel: '/img/scene-travel.webp',
  // Stand-in until the real portrait of Tusar-da / the office front arrive
  founder: '/img/desk.webp',
  office: '/img/haldia.webp',
  goalEducation: '/img/goal-education.webp',
  goalRetirement: '/img/goal-retirement.webp',
  goalHome: '/img/goal-home.webp',
  goalMarriage: '/img/goal-marriage.webp',
};
